import { appContext } from '../AppContext';
import { SurveyAnswer } from './data';

export function completeSurvey() {
  // track event selection
  appContext.onboardingSurveyCompleted = true;
}

export function shuffleAnswers(answers: SurveyAnswer[]) {
  let currentIndex = answers.length;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {
    // Pick a remaining element.
    const randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [answers[currentIndex], answers[randomIndex]] = [answers[randomIndex], answers[currentIndex]];
  }

  return answers;
}
